import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';
import { fetchCrops } from '../../../features/crops/cropSlice';

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  disabled?: boolean;
}

export const CropSelect: React.FC<Props> = ({ 
  value, 
  onChange, 
  error,
  disabled = false 
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { crops, loading } = useSelector((state: RootState) => state.crops);

  useEffect(() => {
    dispatch(fetchCrops());
  }, [dispatch]);

  const formatCropLabel = (crop: any) => {
    return crop.variety ? `${crop.name} (${crop.variety.name})` : crop.name;
  };

  return (
    <div>
      <label htmlFor="crop_id" className="block text-sm font-medium text-gray-700">
        {t('sales.crop')} *
      </label>
      <select
        id="crop_id"
        name="crop_id"
        value={value}
        onChange={onChange}
        disabled={disabled || loading}
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
          focus:border-green-500 focus:ring-green-500 sm:text-sm
          disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">{t('common.select')} {t('sales.crop')}</option>
        {crops.map(crop => (
          <option key={crop.id} value={crop.id}>
            {formatCropLabel(crop)}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};